import "./../App.css";
import { Tooltip } from "react-tooltip";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LinkCard from "../components/LinkCard";
import { mySkills } from "../data/Skills";
import { skillType } from "../data/Types";
import { workHistory } from "../data/LinkCardEntries";
import TextCard from "../components/TextCard";
import { Link } from "react-router-dom";

export default function WorkLife() {
  const ResumeText =
    "Take a look at my resume, or view my work history and software experience below.";
  function RenderSkills(header: string, skillType: skillType) {
    return (
      <>
        <h3 className="text-3xl xsw:text-2xl 2xsm:text-xl">{header}:</h3>
        <div className="gap-8 2xsw:gap-4 flex flex-row flex-wrap">
          {mySkills
            .filter((skill) => skill.skillType === skillType)
            .map((skill) => {
              if (skill.imgPath) {
                return (
                  <>
                    <img
                      className="card border drop-shadow-md border-gray rounded-lg bg-white p-4 h-36 w-36 smw:h-24 smw:w-24"
                      src={skill.imgPath}
                      alt={skill.imgAlt}
                      data-tooltip-id={`${skill.name}-tooltip`}
                    />
                    <Tooltip id={`${skill.name}-tooltip`}>{skill.name}</Tooltip>
                  </>
                );
              } else {
                return (
                  <div className="card border flex items-center justify-center drop-shadow-md border-gray rounded-lg px-4 pb-2 bg-white h-36 w-36 smw:h-24 smw:w-24">
                    <p className="text-center font-bold text-3xl smw:text-lg">
                      {skill.name}
                    </p>
                  </div>
                );
              }
            })}
        </div>
      </>
    );
  }
  return (
    <div className="App min-w-screen min-h-screen bg-home-page">
      <Navbar />
      <h1 className="text-5xl text-center my-8">My Career</h1>
      <div className="px-80 mdw:px-40 smw:px-20 xsw:px-10 gap-10 flex flex-col place-content-evenly mb-8">
        <TextCard message={ResumeText} />
        <div className="flex flex-row justify-center">
          <Link
            className="card rounded-lg border border-gray-400 bg-white drop-shadow-md py-4 px-6 flex hover:opacity-80 active:bg-gray-200"
            to="/resume"
          >
            <p className="w-full text-3xl text-center">View Resume</p>
          </Link>
        </div>
      </div>
      <div className="px-80 mdw:px-40 smw:px-20 xsw:px-4 gap-10 flex flex-col place-content-evenly mb-8">
        <h2 className="text-4xl">Work History:</h2>
        {workHistory.map((e) => (
          <LinkCard entry={e} />
        ))}
      </div>
      <div className="px-80 mdw:px-40 smw:px-20 xsw:px-10 flex flex-col gap-10 2xsw:gap-6 place-content-evenly mt-16 mb-12">
        <h2 className="text-4xl smw:text-3xl">My Skills and Technologies:</h2>
        {RenderSkills("Programming Languages", skillType.programmingLanguage)}
        {RenderSkills("Software Frameworks", skillType.softwareFramework)}
        {RenderSkills("Deployment and Management", skillType.deployment)}
        {RenderSkills("Interactive Digital Editors", skillType.ide)}
        {RenderSkills("Operating Systems and OS Distributions", skillType.os)}
        {RenderSkills("Development Workflow", skillType.developmentWorkflow)}
        {RenderSkills("CLI and Package Managers", skillType.cli)}
        {RenderSkills(
          "Python Libraries and Utilities",
          skillType.pythonUtility
        )}
        {RenderSkills("Web Development & Design", skillType.webDevelopment)}
        {RenderSkills("Database Development", skillType.databaseDevelopment)}
        {RenderSkills("File Formats", skillType.fileFormat)}
        {RenderSkills("Communication Software", skillType.communication)}
        {RenderSkills("Other Technologies", skillType.other)}
      </div>
      <Footer />
    </div>
  );
}
